import { render, staticRenderFns } from "./product-history-list.vue?vue&type=template&id=c7cff378"
import script from "./product-history-list.vue?vue&type=script&lang=js"
export * from "./product-history-list.vue?vue&type=script&lang=js"
import style0 from "./product-history-list.vue?vue&type=style&index=0&id=c7cff378&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports